import React from "react";
import I18n from "../../../i18n/";
import { ArrayUtil, DateUtil, OrgUtil } from "../../../util";
import ReportAction from "../../../actions/ReportAction";
import { StressTestSupportGraph } from "../../../constants/supportGraph";
import { StressGeneric } from "./index";

export default (props)=><StressGeneric 
	typeKey={StressTestSupportGraph.AgeRange}
	subHeader={I18n.t("age_range")}
	fetchMain={ReportAction.fetchStressAge}
/>;


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Stress/StressByAge.js